export default "__VITE_ASSET__CDhOzP2a__"